module.exports = __webpack_public_path__ + "img/BannerBancoBarrio.ce340f44.png";